module.exports = __webpack_public_path__ + "img/inactive-codingtest.a4c70888.svg";